import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

import { SideButtons } from '../../interfaces';

@Component({
  selector: 'phoenix-side-buttons',
  templateUrl: './side-buttons.component.html',
  standalone: false,
})
export class SideButtonsComponent {
  isOpen = false;
  @Input() buttons: SideButtons[] = [];
  @Input() positionOptions: 'left' | 'right' | 'up' | 'down' = 'down'; //Controls the menu with option buttons position
  @Input() positionButton: 'left' | 'right' | 'up' | 'down' = 'up'; //Controls the Main button position
  @Input() mainButtonImage = '';
  @Input() ariaLabel: string = '';
  @Output() buttonClicked = new EventEmitter<{
    id: string;
    action?: () => void;
  }>();

  get classForPosition(): string {
    const positionClasses: { [key: string]: string } = {
      // Available positions for options buttons when main button is in UP position
      'left-up': '!flex-row-reverse !top-4 !-translate-x-6 !right-1/2',
      'right-up': '!flex-row !top-4 !translate-x-8 !left-1/2',
      'down-up':
        '!flex-col !top-4 !translate-y-[52px] !translate-x-7 !right-1/2',
      // Available positions for options buttons when main button is in RIGHT position
      'up-right': '!flex-col-reverse !bottom-1/2 !-translate-y-1 !right-4',
      'down-right': '!flex-col !top-1/2 !translate-y-[52px] !right-4',
      'left-right': '!flex-row-reverse !top-1/2 !-translate-x-[52px] !right-4',
      // Available positions for options buttons when main button is in DOWN position
      'left-down': '!flex-row-reverse !bottom-4 !-translate-x-6 !right-1/2',
      'right-down': '!flex-row !bottom-4 !translate-x-8 !left-1/2',
      'up-down':
        '!flex-col-reverse !bottom-4 !-translate-y-[52px] !translate-x-7 !right-1/2',
      // Available positions for options buttons when main button is in LEFT position
      'up-left': '!flex-col-reverse !bottom-1/2 !-translate-y-1 !left-16',
      'down-left': '!flex-col !top-1/2 !translate-y-[52px] !left-16',
      'right-left': '!flex-row !top-1/2 !translate-x-[52px] !left-16',
    };

    const positionKey = `${this.positionOptions}-${this.positionButton}`;
    return positionClasses[positionKey] || '';
  }

  toggleActive(event: MouseEvent): void {
    event.stopPropagation();

    this.isOpen = !this.isOpen;
  }

  @HostListener('document:click', ['$event'])
  closeButtonOnClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('button[name="MainSideBtn"]')) {
      this.isOpen = false;
    }
  }
}
